import { axios } from '@/plugins/axios';
import { Event } from '@/models/Event';

export class AccountService {
  endpoint: string;

  events: Event[] = [];

  constructor() {
    this.endpoint = 'v1/accounts/';
  }

  async fetchAccounts() {
    return axios.get(`${this.endpoint}users/`).then(({ data }) => data);
  }

  async fetchMe() {
    return axios.get(`${this.endpoint}auth/user/`).then(({ data }) => data);
  }

  async fetchAccount(id: number) {
    return axios.get(`${this.endpoint}users/${id}`).then(({ data }) => data);
  }

  async createAccount(payload: object) {
    return axios
      .post(`${this.endpoint}users/`, payload)
      .then(({ data }) => data);
  }

  async updateAccount(id: number, payload: object) {
    return axios
      .patch(`${this.endpoint}users/${id}`, payload)
      .then(({ data }) => data);
  }

  async deleteAccount(id: number) {
    return axios.delete(`${this.endpoint}users/${id}`);
  }

  async getCurrentUserEvents() {
    const { events } = await this.fetchMe();
    this.events = events;
    return events[0];
  }
}
